import styled from 'styled-components';

export const NavbarContainer = styled.header<{ collapsed: boolean }>`
  /* border-top: 2px solid #57069e; */
  height: 60px;
  background: #521eab;
  /* background: #320459; */
  color: #fcfcfe;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  position: fixed;
  top: 0;
  left: ${({ collapsed }) => (collapsed ? '70px' : '450px')};
  right: 0;
  z-index: 1001;
  transition: left 0.3s ease;
`;

export const ToggleSidebarButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  transition: background-color 0.2s ease;

  &:hover {
    background: #6e40bd;
  }
`;

export const MenuButton = styled.div`
  position: relative;
  padding: 8px 12px;
  border-radius: 6px;
  transition: background-color 0.2s ease;

  &:hover {
    background: #6e40bd;
  }
`;

export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  color: #fff;
`;

export const RightSection = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
`;

export const Avatar = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
`;

export const Dropdown = styled.ul`
  position: absolute;
  top: 50px;
  right: 0;
  background: #521eab;
  border: 1px solid #1e282c;
  border-radius: 4px;
  list-style: none;
  padding: 0;
  margin: 0;
  min-width: 200px;
  z-index: 1002;
`;

export const DropdownItem = styled.li<{ selected?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 16px;
  color: #fff;
  gap: 10px;
  cursor: pointer;
  border-radius: 4px;

  background: ${({ selected }) => (selected ? '#6e40bd' : '')};

  &:hover {
    background: #6e40bd;
    color: #fff;
  }
`;

export const NavMenuCard = styled.div`
  position: absolute;
  top: 50px;
  right: 0;
  background: #521eab;
  border: 1px solid #1e282c;
  border-radius: 4px;
  list-style: none;
  padding: 5px 10px 5px 10px;
  margin: 0;
  width: max-content;
  z-index: 1002;
`;

export const NavMenuHeader = styled.div`
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
